export const HR_PROFILE_PERMISSION_CODES = {
    WEB_HR_PROFILE_LIST: 'WEB_HR_PROFILE_LIST',
    WEB_HR_PROFILE_DETAIL: 'WEB_HR_PROFILE_DETAIL',
    WEB_HR_PROFILE_ADD: 'WEB_HR_PROFILE_ADD',
    WEB_HR_PROFILE_EDIT: 'WEB_HR_PROFILE_EDIT',
    WEB_HR_PROFILE_DELETE: 'WEB_HR_PROFILE_DELETE',
    WEB_HR_PROFILE_IMPORT: 'WEB_HR_PROFILE_IMPORT',
    WEB_HR_PROFILE_EXPORT: 'WEB_HR_PROFILE_EXPORT',
} as const;

